import LimitIncreaseIncomeDocument from "./LimitIncreaseIncomeDocument";

const JSON_KEY_ID = "id";
const JSON_KEY_LIMIT_INCREASE_ID = "limit-increase-id";
const JSON_KEY_SOURCE = "source";
const JSON_KEY_SOURCE_DISPLAY = "source-display";
const JSON_KEY_VALUE = "value";
const JSON_KEY_INCOME_DOCUMENTS = "income-documents";


export default class LimitIncreaseSourceOfIncome {

    constructor(jsonResponse) {

        this.id = jsonResponse[JSON_KEY_ID];
        this.limitIncreaseId = jsonResponse[JSON_KEY_LIMIT_INCREASE_ID];
        this.source = jsonResponse[JSON_KEY_SOURCE];
        this.sourceDisplay = jsonResponse[JSON_KEY_SOURCE_DISPLAY];
        this.value = jsonResponse[JSON_KEY_VALUE];

        this.incomeDocuments = [];
        if (Array.isArray(jsonResponse[JSON_KEY_INCOME_DOCUMENTS])) {
            jsonResponse[JSON_KEY_INCOME_DOCUMENTS].forEach(incomeDocument => {
                this.incomeDocuments.push(new LimitIncreaseIncomeDocument(incomeDocument));
            })
        }
    }

    static toJson(sourceOfIncome) {
        let jsonObject = {};
        jsonObject[JSON_KEY_SOURCE] = sourceOfIncome.source;
        jsonObject[JSON_KEY_VALUE] = sourceOfIncome.value;

        let incomeDocuments = [];
        sourceOfIncome.incomeDocuments.forEach(incomeDocument => {
            incomeDocuments.push(LimitIncreaseIncomeDocument.toJson(incomeDocument));
        });
        jsonObject[JSON_KEY_INCOME_DOCUMENTS] = incomeDocuments;

        return jsonObject;
    }
}
